(function () {
  if (window.__vilaBellySupportLoaded) return;
  window.__vilaBellySupportLoaded = true;

  function pad(number) {
    return String(number).padStart(2, "0");
  }

  function tickCountdown() {
    var nodes = document.querySelectorAll("[data-vila-countdown]");
    if (!nodes.length) return;

    var now = new Date();
    var end = new Date(now);
    end.setHours(23, 59, 59, 999);

    var seconds = Math.max(0, Math.floor((end - now) / 1000));
    var hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    var minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    var markup =
      '<span class="seg">' + pad(hours) + "<i>h</i></span>" +
      '<span class="seg">' + pad(minutes) + "<i>m</i></span>" +
      '<span class="seg">' + pad(seconds) + "<i>s</i></span>";

    nodes.forEach(function (node) {
      node.innerHTML = markup;
    });
  }

  function initBuyBoxes() {
    document.querySelectorAll("[data-vila-buy-box]").forEach(function (box) {
      var form = box.matches("form") ? box : box.querySelector("form");
      if (!form) return;

      var idInput = box.querySelector('[name="id"]');
      var quantityInput = box.querySelector('[name="quantity"]');
      var rows = box.querySelectorAll("[data-vila-variant-row]");

      rows.forEach(function (row) {
        row.addEventListener("click", function () {
          rows.forEach(function (item) {
            item.classList.remove("is-active");
            var input = item.querySelector('input[type="radio"]');
            if (input) input.checked = false;
          });

          row.classList.add("is-active");
          var radio = row.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
          if (idInput) idInput.value = row.getAttribute("data-variant-id");
          if (quantityInput) quantityInput.value = row.getAttribute("data-quantity") || "1";
        });
      });

      form.addEventListener("submit", function (event) {
        var submitter = event.submitter;
        if (!submitter || !submitter.hasAttribute("data-vila-buy-now")) return;

        event.preventDefault();
        var error = box.querySelector("[data-vila-error]");
        var formData = new FormData(form);

        submitter.disabled = true;
        if (error) error.classList.remove("is-visible");

        // 1. Clear the cart first
        fetch("/cart/clear.js", {
          method: "POST",
          headers: { Accept: "application/json" }
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Cart clear failed");
            
            // 2. Add the new item
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { Accept: "application/json" },
              body: formData
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error("Cart add failed");
            
            // 3. Redirect to checkout (na vilapure.ba kapija prvo otvara EasySell)
            if (window.vilaCheckout) window.vilaCheckout.go("/checkout");
            else window.location.href = "/checkout";
          })
          .catch(function () {
            // This now only handles showing the error message
            if (error) {
              error.textContent = error.getAttribute("data-default-message");
              error.classList.add("is-visible");
            }
          })
          .finally(function () {
            // This always runs, ensuring the button is re-enabled
            submitter.disabled = false;
          });
      });
    });
  }

  function initReveal() {
    var nodes = document.querySelectorAll(".vila-reveal");
    if (!nodes.length) return;

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (node) {
        node.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function init() {
    tickCountdown();
    setInterval(tickCountdown, 1000);
    initBuyBoxes();
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();